import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const GearIcon16 = (props: SvgProps) => <Svg
  width={16}
  height={16}
  viewBox='0 0 16 16'
  fill='none'
  {...props}
>
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M3 1C1.89543 1 1 1.89543 1 3V13C1 14.1046 1.89543 15 3 15H13C14.1046 15 15 14.1046 15 13V3C15 1.89543 14.1046 1 13 1H3ZM8.09246 11.4518H7.91293L6.47441 12.2424C5.91441 12.057 5.39499 11.7691 4.94343 11.3939L4.93804 9.80303C4.90617 9.75354 4.8761 9.7036 4.84827 9.65234L3.41784 8.85025C3.30517 8.28914 3.30517 7.71174 3.41784 7.15063L4.84693 6.35076C4.8761 6.29994 4.90617 6.24956 4.9367 6.20006L4.94388 4.60915C5.39503 4.23292 5.91431 3.944 6.47441 3.75758L7.91068 4.54817H8.09022L9.52649 3.75758C10.0865 3.94304 10.6059 4.23091 11.0575 4.60606L11.0629 6.19697C11.0947 6.24646 11.1248 6.2964 11.1526 6.34766L12.5822 7.14931C12.6948 7.71042 12.6948 8.28782 12.5822 8.84893L11.1531 9.6488C11.1239 9.69962 11.0938 9.75 11.0633 9.79949L11.0561 11.3904C10.6053 11.7667 10.0863 12.0558 9.52649 12.2424L8.09246 11.4518ZM8.00044 9.76768C8.99198 9.76768 9.79578 8.97626 9.79578 8C9.79578 7.02374 8.99198 6.23232 8.00044 6.23232C7.0089 6.23232 6.20509 7.02374 6.20509 8C6.20509 8.97626 7.0089 9.76768 8.00044 9.76768Z'
    fill={props.fill ?? '#8AB2D9'}
  />
</Svg>;

export default GearIcon16;
